import styled from "styled-components";
import Loader from "../../components/Loader/Loader";

export const StyledHorizontalRule = styled.hr`
  border-top: #000000 .063rem solid;
  min-width: 100%;
`;

export const StyledDownloadingLoader = styled(Loader)`
  width: 1.5rem;
  height: 1.5rem;
  flex-grow: unset;
  & > div {
    height: 1.5rem;
    width: 1.5rem;
    & > div {
      height: 1.5rem;
      width: 1.5rem;
      border-width: 0.125rem;
    }
  }
`;